// extracted by mini-css-extract-plugin
module.exports = {"item":"styles_item__mbLQr","icon":"styles_icon__CfCTp","globalInfo":"styles_globalInfo__FTQds"};